// removed by extract-text-webpack-plugin
module.exports = {"highlight-needoffer-tab":"highlight-needoffer-tab","highlight-needoffer-title":"highlight-needoffer-title","highlight-needoffer-content":"highlight-needoffer-content","left-content":"left-content","right-content":"right-content","view-more-item":"view-more-item","view-more-link":"view-more-link"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_HighlightNeedOfferTab.scss
// module id = ./components/home/sub-view/_HighlightNeedOfferTab.scss
// module chunks = 0